<template>
  <section>
          
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark evangelio-lectura ">
        <a class="navbar-brand p-3" href="/"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
       
          <button  v-if="isAuthenticated" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

         <div v-if="isAuthenticated" class="collapse navbar-collapse"  id="navbarNavDropdown">
          <ul class="navbar-nav"  style="margin-left: auto;">
           
            <li class="nav-item dropdown active">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Misal
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link class="dropdown-item" to="/misas">Todas las misas</router-link>
                <router-link class="dropdown-item" to="/misas/agrega">Agregar misa</router-link>
              </ul>
            </li>
             <li class="nav-item">
              <a class="nav-link" href="#" @click="logout()">Cerrar Sesión</a>
            </li>
          </ul>
        </div>
     
    </nav>
    <img class="loading" v-if="isLoading" src="/images/loading-buffering.gif" alt="Cargando...">
    <div class="container-fluid p-5 pt-2" >
        <div class="justify-content-end d-flex p-3">
            <router-link to="/misas/agrega" class="btn btn-success"><PlusIcon /> Agrega Evangelio</router-link>
        </div>
      <div class="row ">
        <div class="col-md-9 col-12">
            <div class="row row-cols-1 row-cols-md-4">
                <div class="col mb-4" v-for="(evangelio, indx) in filteredEvangelios" :key="evangelio.MIS_ID">
                  <div class="card h-100" >
                      <div class="card-header ">
                          <h6 class="text-center text-uppercase" style="letter-spacing:4px;font-size:12px">
                              {{format(evangelio.MIS_FECHA,"MMMM D YYYY")}}
                          </h6>
                      </div>
                      <div class="card-body">
                          <h6 class="card-title">{{evangelio.MIS_EVANGELIO_VERSICULO}}</h6>
                          <p class="card-text" v-html=" truncated(evangelio.MIS_EVANGELIO)"></p>
                      </div>
                      <div class="card-footer text-muted">
                          <div class="row">
                              <div class="col-6">
                                  <button type="button" class="btn btn-outline-danger btn-sm" @click="borrarMisa(indx,evangelio.MIS_ID)">Borrar</button>
                              </div>
                              <div class="col-6">
                                  <router-link :to="'/misas/editar/'+evangelio.MIS_ID" class="btn btn-outline-success btn-sm" >Editar</router-link>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-12">
            <h6 class="pb-3">Código QR</h6>
            <div class="w-100 pb-4">
                <router-link to="/imprimirqr" type="button" class="btn btn-primary btn-sm btn-block w-100 p-2" >Imprimir QR</router-link>
            </div>

            <h6 class="pb-3">Filtros de Búsqueda</h6>
            <div class="pb-5"><input type="text" placeholder="Buscar..." v-model="filtro" class="form-control form-control-xs" /> </div>

            <div class="m-auto w-100 ">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="isfiltroFecha" id="defaultCheck1">
                  <label class="form-check-label" for="defaultCheck1">
                    Buscar por fecha
                  </label>
                </div>
                <DatePicker :disabled="!isfiltroFecha" v-model="filtroFecha" inline autoApply :enableTimePicker="false"  />
            </div>
        </div>    
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

require('moment/locale/es')
import PlusIcon from 'vue-material-design-icons/Plus.vue'

export default {
 
  components:{PlusIcon},
  data(){
    return{
      date: '',
      textLength:100,
      suffix: '...',
      isLoading: false,
      evangelios: [],
      filtro: '',
      filtroFecha: '',
      isfiltroFecha:false
    }
  },
  methods:{
    format(date,format){
      return moment(date).format(format);
    },
    truncated(text){
        if(text.length > this.textLength){
          return text.substring(0, this.textLength) + this.suffix;
        }
        return text;
    },
    borrarMisa(indx,idEvangelio){
      fetch(process.env.VUE_APP_PHP_URL,{
              method:'POST',
              body: JSON.stringify({ accion: 'deleteMisa',id: idEvangelio })
        }).then((res)=> res.json())
        .finally(()=>{
          this.evangelios = this.evangelios.splice(indx,1)
        })
    },
    async getEvangelios(){
        this.isLoading = true;
        await fetch(process.env.VUE_APP_PHP_URL,{
              method:'POST',
              body: JSON.stringify({  accion: 'getMisas'})
        }).then((res)=> res.json())
        .then((data)=>{
          this.evangelios = data;
        }).finally(()=>{
          this.isLoading = false;
        })
    },
    logout(){
      this.$auth0.logout({ returnTo: window.location.origin });
    }
  },
  computed:{
     isAuthenticated(){
          return this.$auth0.isAuthenticated.value
      },
    filteredEvangelios(){
      return this.evangelios.filter((ev) => {
        return ev.MIS_EVANGELIO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_REFLEXION.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_PRIMERALECTURA.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_SEGUNDALECTURA.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_MEDITATIO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_ORATIO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_ACTIO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_EVANGELIO_VERSICULO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_PRIMERALECTURA_VERSICULO.toLowerCase().includes(this.filtro.toLowerCase()) || 
               ev.MIS_SEGUNDALECTURA_VERSICULO.toLowerCase().includes(this.filtro.toLowerCase());
      }).filter((ev)=>{
        if(this.isfiltroFecha){
          return ev.MIS_FECHA.includes( this.formatedDate );
        }
        return ev;
      });
    },
    formatedDate(){
        return moment(this.filtroFecha).format('YYYY-MM-DD');
    }
  },
  created(){
       this.getEvangelios();
  }
}
</script>